import netsGreetingsList from './nets-greetings-list';
import moduleConfig from './module-config';

export default angular
  .module('app.greetings', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsGreetingsList', netsGreetingsList);
